import { useEffect } from "react";
import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";
import PageTitle from "components/text/PageTitle";
import SectionTitle from "components/text/SectionTitle";

import ClaimRewardContainer from "./ClaimRewardContainer";
import ButtonPrimarySmallIcon from "components/buttons/ButtonPrimarySmallIcon";
import RewardHistoryContainer from "./RewardHistoryContainer";

import giftIcon from "assets/img/icons/icons8-gift.svg";
import telegramIcon from "assets/img/icons/icons8-telegram.svg";
import telegramWhiteIcon from "assets/img/icons/icons8-telegram-white.svg";

const TelegramRewards = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

const RewardInfoBox = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const BoxTitle = styled.div`
  width: 100%;

  line-height: 130%;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};
`;

const GiftIcon = styled.div`
  display: inline-block;
  padding-right: 6px;

  transform: translateY(4.5px);

  width: 27px;
  min-width: 27px;
`;

const Text = styled.div`
  line-height: 125%;
`;

const JoinButtonWrap = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN};

  display: flex;
`;

export default () => {
  // set page Title
  useEffect(() => {
    document.title = "Telegram Rewards | Scalelup";
  }, []);

  return (
    <Layout>
      <TelegramRewards>
        <PageTitle>Telegram Rewards</PageTitle>
        <RewardInfoBox>
          <BoxTitle>
            <GiftIcon>
              <img src={giftIcon} style={{ width: "100%" }} />
            </GiftIcon>
            Follow Our Telegram Channel and Earn Rewards
          </BoxTitle>
          <Text>
            Our Telegram channel is full of exciting opportunities from our
            Bronze, Silver, and Gold users. It also offers cash rewards for
            those who follow it regularly.
          </Text>
          <JoinButtonWrap>
            <ButtonPrimarySmallIcon
              icon={telegramIcon}
              iconHover={telegramWhiteIcon}
              onClick={() => {
                window.open("https://t.me/scalelupcom", "_blank");
              }}
            >
              Join Our Channel
            </ButtonPrimarySmallIcon>
          </JoinButtonWrap>
        </RewardInfoBox>
        <SectionTitle>Claim Reward</SectionTitle>
        <ClaimRewardContainer />
        <SectionTitle>Reward History</SectionTitle>
        <RewardHistoryContainer />
      </TelegramRewards>
    </Layout>
  );
};
